import { getJitsiRoomName } from "./jitsiUtils";

const Configuration = {
    DEBUG: false,

    USE_VIDEO_FIXTURES: false,
    SHUFFLE_RANDOM_FIXTURES: false,
    NUM_VIDEO_FIXTURES: 8,

    danceFloorBackground: {
        ENABLED_BY_DEFAULT: false,
    },

    DEFAULT_DOCUMENT_TITLE: "digital dance hall",
    LS_NAMESPACE: "vclub",
    AUTO_JOIN_ROOM: false,
    VIDEO_ASPECT_RATIO_LANDSCAPE: 1.7,
    VIDEO_ASPECT_RATIO_PORTRAIT: 1.4,
    ENABLE_SELF_VIDEO_EFFECTS: false,
    NUM_VIRTUAL_BACKGROUNDS: 8,

    SHOW_MARQUEE: true,
    roomMarqueeInfo: {
        "thesis-presentation": {
            text: "📵 No screenshots on the dance floor ✨",
            link: "",
        },
        [getJitsiRoomName({ twitchChannel: "comf0rtzone" })]: {
            text: "📵 No screenshots on the dance floor ✨",
            link: "https://soundcloud.com/djcomfortzone/",
        },
        [getJitsiRoomName({ twitchChannel: "lunchboxny" })]: {
            text: "Help us donate 10,000 nutritious, plant-based meals in NYC!  🥕  🥦  🍄  Click here to donate",
            link: "https://www.lunchboxnyc.org/#donation",
        },
    } as { [key: string]: { text: string; link: string } },

    PERFORMANCE_CHAT_KEYWORDS: {
        yellow: ["happy", "good", "great", "cool", "wow", "omg"],
        blue: ["sad", "shit", "bummer", "hate", "damn", "love"],
        green: ["lmao", "lmfao", "lol", "rofl", "haha"],
        red: ["what's up", "whats up", "sup", "nm", "not much", "you?", "hbu", "how are you"],
        pink: ["hug", "kiss", "heart", "laugh", "smile", "frown"],
    },
};

export default Configuration;
